import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import { service } from '@ember/service';
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';

import DateRangeDisplaySimple from 'rise-ui/components/date-range-display-simple.gjs';
import AddButton from 'rise-ui/components/time-series/selection/output/actions/add-button.gjs';
import Dates from 'rise-ui/components/time-series/selection/output/actions/dates.gjs';
import and from 'rise-ui/helpers/and.js';
import availableDates from 'rise-ui/helpers/available-dates.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import dateUnbound from 'rise-ui/helpers/date-unbound.js';
import fnx from 'rise-ui/helpers/fnx.js';
import oneString from 'rise-ui/helpers/one-string.js';
import or from 'rise-ui/helpers/or.js';
import qpDateRangeInvalid from 'rise-ui/helpers/qp-date-range-invalid.js';
import qpDateRel from 'rise-ui/helpers/qp-date-rel.js';
import timeSeriesSelect from 'rise-ui/helpers/time-series-select.js';
import titleCase from 'rise-ui/helpers/title-case.js';

export default class TimeSeriesSelectionLineModelRunComponent extends Component {
  @service('time-series/dates') dates;

  <template>
    {{#let (availableDates @modelRun) as | availableDates |}}
    {{#let
      (or
        (dateUnbound availableDates.from availableDates.to @dateRanges)
        (qpDateRangeInvalid availableDates @dateRanges)
      )
      as | isDateRangeInvalid |
    }}
    <div
      class={{concatClasses
        "c-time-series-selection-line c-time-series-selection-output"
        "c-time-series-selection-line-model-run c-lined__line"
        (if @isValid "c-time-series-selection-output--valid")
      }}
      data-qa-output="modeled"
      data-qa-output-id={{@modelRun.id}}
      ...attributes
    >
      <div class="c-time-series-selection-line__wrapper">
        <span role="button"
          class="c-time-series-selection-line-actions c-time-series-selection-line-actions--slim dummy-button"
          {{on "click" (stopPropagation)}}
        >
          <AddButton
            @name={{titleCase (oneString
              @modelRun.item.hasProfile "model-run-profile"
              true "model-run"
            )}}
            @isSelected={{@isSelected}}
            @linkTo={{timeSeriesSelect toggleModelRun=@modelRun.id}}
          />
        </span>
        <Dates
          @availableDates={{availableDates}}
          @dateRanges={{@dateRanges}}
          @isDateRangeInvalid={{isDateRangeInvalid}}
          @onDatesChange={{fnx this.dates.onModelRunDateChange @modelRun.id}}
          @linkToClear={{timeSeriesSelect clearModelRunDates=@modelRun.id}}
          @linkToCopy={{timeSeriesSelect
            addModelRun=@modelRun.id
            copyDefaultDates=true
          }}
          @linkToWeek={{timeSeriesSelect
            addModelRun=@modelRun.id
            setModelRunDates=(qpDateRel "week")
          }}
          @linkToMonth={{timeSeriesSelect
            addModelRun=@modelRun.id
            setModelRunDates=(qpDateRel "month")
          }}
          @linkToYear={{timeSeriesSelect
            addModelRun=@modelRun.id
            setModelRunDates=(qpDateRel "year")}}
          @linkTo10Years={{timeSeriesSelect
            addModelRun=@modelRun.id
            setModelRunDates=(qpDateRel "decade")
          }}
          @linkToAll={{timeSeriesSelect
            addModelRun=@modelRun.id
            setModelRunDates=(qpDateRel "all")
          }}
          @onDropdownSelection={{@onDateDropdownSelection}}
          @datesRequired={{@datesRequired}}
        />
        <span class="c-time-series-selection-line__type">
          {{titleCase (oneString
            @modelRun.item.hasProfile "model-run-profile"
            true "model-run"
          )}}
          - Output
        </span>
        <span class="c-time-series-selection-line__label">
          {{@modelRun.title}}
          {{~#if (and @modelRun.temporalStartDate @modelRun.temporalEndDate)}}
            <DateRangeDisplaySimple
              title="Available Date Range"
              class="c-time-series-selection-line__section-dates"
              @fromDate={{@modelRun.temporalStartDate}}
              @toDate={{@modelRun.temporalEndDate}}
            />
          {{~/if~}}
        </span>
      </div>
    </div>
    {{/let}}
    {{/let}}
  </template>
}
